<div class="flex notification-msg icon"
[ngClass]="{'info': data.type === 'info', 
                 'err': data.type === 'error', 
                 'success': data.type === 'success'}">
    <ng-template [ngIf]="data.type === 'info'">
        <mat-icon class="snack-icon infoColor">info</mat-icon>
    </ng-template>
    <ng-template [ngIf]="data.type === 'success'">
        <mat-icon class="snack-icon successColor">check_circle</mat-icon>
    </ng-template>
    <ng-template [ngIf]="data.type === 'error'">
        <mat-icon class="snack-icon errorColor">info</mat-icon>
    </ng-template>
    <div class="data">{{data.message}}</div>

    <button mat-button class="close-icon close"    
    (click)="snackBarRef.dismiss()" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
  
